<div class="container pt-3 fade-in-left" id="centerFrame" >
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Más</h1></div>
        <div class="p-2 pl-2 help" (click)="openhelp()"><i class="bi bi-info-circle"></i></div>
    </div>
    <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
        <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
        <div class="col" id="helpinfo"></div>
        <div class="col-auto" (click)="openhelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2">
        <!-- <a [routerLink]="['/dashboard']"><div class="row p-3">
            <div class="col-auto d-flex align-items-center"><i class="bi bi-house"></i></div><div class="col px-4 d-flex align-items-center">Inicio</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
        </div></a> -->
        <a [routerLink]="['/my-account']"><div class="row p-3">
            <div class="col-auto d-flex align-items-center"><i class="bi bi-person-bounding-box"></i></div><div class="col px-4 d-flex align-items-center">Mi Cuenta</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
        </a>
        @if(id_perfil == 2 || id_perfil == 3){
            <a [routerLink]="['/turnos']"><div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-calendar2-check"></i></div><div class="col px-4 d-flex align-items-center">Historial de turnos</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        }
        @if(id_perfil == 2){
            <a [routerLink]="['/pedidos']"><div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-bag"></i></div><div class="col px-4 d-flex align-items-center">Mis Compras</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        }
        @if(id_perfil == 4){
            <a [routerLink]="['/pedidos']"><div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-bag"></i></div><div class="col px-4 d-flex align-items-center">Mis Ventas</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        }
        <!--<div class="row p-3">
            <div class="col-1"><img src="./assets/img/account/icono-integrantes.png" alt="Ir a Integrantes"></div><div class="col-10 px-4">Integrantes</div>
        </div>-->
        <a [routerLink]="['/ayuda']"><div class="row p-3">
            <div class="col-auto d-flex align-items-center"><i class="bi bi-question-circle"></i></div><div class="col px-4 d-flex align-items-center">Ayuda</div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
        </a>
    </div>

    <hr class="divisor mt-3 mb-3">
    @if(id_perfil == 1){
        <div class="row-cols-12 m-2">
            <a [routerLink]="['/more-usuarios']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Usuarios</div><div class="col-10 text-detail-item">ABM de Usuarios</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-prestadores']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Prestadores</div><div class="col-10 text-detail-item">ABM de Prestadores</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-comercios']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Comercios</div><div class="col-10 text-detail-item">ABM de Comercios</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-administradores']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Administradores</div><div class="col-10 text-detail-item">ABM de Administradores</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        </div>

        <hr class="divisor mt-3 mb-3">

        <div class="row-cols-12 m-2">
            <a [routerLink]="['/more-ordenes-prestador']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-calendar2-check"></i></div><div class="col"><div class="col-10 text-title-item">Órdenes de Prestador</div><div class="col-10 text-detail-item">Administrar todos los turnos</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-ordenes-comercio']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-bag"></i></div><div class="col"><div class="col-10 text-title-item">Órdenes de Comercio</div><div class="col-10 text-detail-item">Administrar todos los pedidos</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        </div>

        <hr class="divisor mt-3 mb-3">

        <div class="row-cols-12 m-2">
            <a [routerLink]="['/more-comunicaciones']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-megaphone"></i></div><div class="col"><div class="col-10 text-title-item">Comunicaciones</div><div class="col-10 text-detail-item">Enviar avisos a usuarios</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        </div>

        <hr class="divisor mt-3 mb-3">

        <div class="row-cols-12 m-2" >
            <a [routerLink]="['/more-tipos-documentos']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Tipos de Documentos</div><div class="col-10 text-detail-item">ABM de Tipos de Documentos</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-obras-sociales']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Obras Sociales</div><div class="col-10 text-detail-item">ABM de Obras Sociales</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-especialidades']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Especialidades</div><div class="col-10 text-detail-item">ABM de Especialidades</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
            <a [routerLink]="['/more-prestaciones']"><div class="row p-3 align-items-center">
                <div class="col-auto"><i class="bi bi-card-heading"></i></div><div class="col"><div class="col-10 text-title-item">Prestaciones</div><div class="col-10 text-detail-item">ABM de Prestaciones</div></div><div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div></div>
            </a>
        </div>

        <hr class="divisor mt-3 mb-3">
    }

    <div class="row-cols-12 m-2">
        <a [routerLink]="['/more-notificaciones']">
            <div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-bell"></i></div>
                <div class="col px-4 d-flex align-items-center">Notificaciones</div>
                <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
            </div>
        </a>
        <a [routerLink]="['/acerca-de']">
            <div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-info-circle"></i></div>
                <div class="col px-4 d-flex align-items-center">Acerca de Libre Salud</div>
                <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
            </div>
        </a>
        <a (click)="logout()" style="cursor: pointer;">
            <div class="row p-3">
                <div class="col-auto d-flex align-items-center"><i class="bi bi-box-arrow-right"></i></div>
                <div class="col px-4 d-flex align-items-center">Cerrar sesión</div>
                <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
            </div>
        </a>
    </div>
    <div class="row-cols-12 m-2 ms-4 pb-3 mb-3">
        <div class="col">
            <div class="mt-3 fw-light"><span class="badge rounded-pill text-dark text-white light-blue-ls">Version {{version}}</span></div>
        </div>
    </div>
    <div class="row-cols-12 m-2 ms-0 pb-3 mb-3 mt-5">
        <a [routerLink]="['/delete-account']" style="cursor: pointer;">
            <div class="row p-3">
                <div class="col px-4 d-flex align-items-center">Eliminar cuenta</div>
                <div class="col-auto"><i class="bi bi-chevron-right align-middle"></i></div>
            </div>
        </a>
    </div>
</div>
